const HUMAN_SUPPORT_CALL_TRANSCRIPT = [
    {
        "payload": {
            "content": "Hello, I'd like to speak to someone about an issue I've been having with my service."
        },
        "from": {
            "userId": "customer@example.com",
            "name": "Customer"
        }
    },
    {
        "payload": {
            "content": "Good afternoon! My name is Suprabath, and I'll be happy to assist you today. May I have your name and account number, please?"
        },
        "from": {
            "userId": "suprabath.chakilam@symbl-support.ai",
            "name": "Suprabath"
        }
    },
    {
        "payload": {
            "content": "Hi Suprabath, this is John Smith. My account number is 123456."
        },
        "from": {
            "userId": "customer@example.com",
            "name": "Customer"
        }
    },
    {
        "payload": {
            "content": "Thank you, John. How can I assist you today?"
        },
        "from": {
            "userId": "suprabath.chakilam@symbl-support.ai",
            "name": "Suprabath"
        }
    },
    {
        "payload": {
            "content": "Well, I've been having consistent issues with my internet service for the past two weeks. It keeps disconnecting randomly, and it's really frustrating, especially when I'm in the middle of important work calls."
        },
        "from": {
            "userId": "customer@example.com",
            "name": "Customer"
        }
    },
    {
        "payload": {
            "content": "I'm really sorry to hear that you've been experiencing these issues, John. I understand how frustrating and inconvenient this must be for you. Let me take a look at your account and see what might be causing these interruptions. Could you please hold for a moment while I pull up your details?"
        },
        "from": {
            "userId": "suprabath.chakilam@symbl-support.ai",
            "name": "Suprabath"
        }
    },
    {
        "payload": {
            "content": "Sure, but I hope this doesn't take too long."
        },
        "from": {
            "userId": "customer@example.com",
            "name": "Customer"
        }
    },
    {
        "payload": {
            "content": "I assure you I'll be as quick as possible. Thank you for your patience."
        },
        "from": {
            "userId": "suprabath.chakilam@symbl-support.ai",
            "name": "Suprabath"
        }
    },
    {
        "payload": {
            "content": "Thank you for holding, John. I see that there have been multiple disconnections logged on your account. To better understand the issue, could you tell me if you've noticed any pattern or specific times when these disconnections happen?"
        },
        "from": {
            "userId": "suprabath.chakilam@symbl-support.ai",
            "name": "Suprabath"
        }
    },
    {
        "payload": {
            "content": "It seems to happen mostly in the afternoons, but it can be pretty random. Sometimes it goes out for a few minutes, other times it's much longer."
        },
        "from": {
            "userId": "customer@example.com",
            "name": "Customer"
        }
    },
    {
        "payload": {
            "content": "Thank you for that information. Based on what I see here, there might be a couple of potential causes. First, I'd like to run a remote diagnostic on your connection. This will help us identify if there are any signal issues or hardware malfunctions. This will only take a couple of minutes. Is that alright with you?"
        },
        "from": {
            "userId": "suprabath.chakilam@symbl-support.ai",
            "name": "Suprabath"
        }
    },
    {
        "payload": {
            "content": "Yeah, go ahead."
        },
        "from": {
            "userId": "customer@example.com",
            "name": "Customer"
        }
    },
    {
        "payload": {
            "content": "Great, please hold on for a moment while I run the diagnostic."
        },
        "from": {
            "userId": "suprabath.chakilam@symbl-support.ai",
            "name": "Suprabath"
        }
    },
    {
        "payload": {
            "content": "John, it appears that your modem is receiving a weak signal, which could be causing these disconnections. One common solution is to reset the modem. Have you tried that yet?"
        },
        "from": {
            "userId": "suprabath.chakilam@symbl-support.ai",
            "name": "Suprabath"
        }
    },
    {
        "payload": {
            "content": "I've tried restarting it a few times, but the problem keeps coming back."
        },
        "from": {
            "userId": "customer@example.com",
            "name": "Customer"
        }
    },
    {
        "payload": {
            "content": "I see. In that case, there are a couple of other steps we can take. Sometimes, the modem's position can affect signal strength. Is your modem placed in a central, open location in your home?"
        },
        "from": {
            "userId": "suprabath.chakilam@symbl-support.ai",
            "name": "Suprabath"
        }
    },
    {
        "payload": {
            "content": "No, it's in a corner of my office. Should I move it?"
        },
        "from": {
            "userId": "customer@example.com",
            "name": "Customer"
        }
    },
    {
        "payload": {
            "content": "Yes, placing the modem in a more central and elevated location can help improve the signal strength. Additionally, ensuring there are no large metal objects or electronic devices nearby can also reduce interference. Would you be able to try moving the modem and see if that improves the connection?"
        },
        "from": {
            "userId": "suprabath.chakilam@symbl-support.ai",
            "name": "Suprabath"
        }
    },
    {
        "payload": {
            "content": "Okay, I'll try that now."
        },
        "from": {
            "userId": "customer@example.com",
            "name": "Customer"
        }
    },
    {
        "payload": {
            "content": "Alright, I've moved it to the living room."
        },
        "from": {
            "userId": "customer@example.com",
            "name": "Customer"
        }
    },
    {
        "payload": {
            "content": "Thank you, John. Let's monitor the connection for a bit to see if there's an improvement. While we wait, I'll also arrange for a technician to visit and check the external lines to ensure there are no issues outside your home. Would that be acceptable?"
        },
        "from": {
            "userId": "suprabath.chakilam@symbl-support.ai",
            "name": "Suprabath"
        }
    },
    {
        "payload": {
            "content": "Yeah, that sounds good. When can the technician come?"
        },
        "from": {
            "userId": "customer@example.com",
            "name": "Customer"
        }
    },
    {
        "payload": {
            "content": "I can schedule a visit for tomorrow afternoon. Would that work for you?"
        },
        "from": {
            "userId": "suprabath.chakilam@symbl-support.ai",
            "name": "Suprabath"
        }
    },
    {
        "payload": {
            "content": "Yes, that works."
        },
        "from": {
            "userId": "customer@example.com",
            "name": "Customer"
        }
    },
    {
        "payload": {
            "content": "Perfect, I've scheduled the technician to arrive between 1 and 3 PM tomorrow. They'll check the external lines and ensure everything is functioning properly. In the meantime, if the issue persists after moving the modem, please let us know immediately."
        },
        "from": {
            "userId": "suprabath.chakilam@symbl-support.ai",
            "name": "Suprabath"
        }
    },
    {
        "payload": {
            "content": "Alright, thanks for your help, Suprabath. I appreciate it."
        },
        "from": {
            "userId": "customer@example.com",
            "name": "Customer"
        }
    },
    {
        "payload": {
            "content": "You're welcome, John. I apologize for the inconvenience you've experienced, and I'm glad we could take steps to resolve it. If you have any other questions or need further assistance, please don't hesitate to reach out. Have a great day!"
        },
        "from": {
            "userId": "suprabath.chakilam@symbl-support.ai",
            "name": "Suprabath"
        }
    },
    {
        "payload": {
            "content": "Thanks, you too. Bye."
        },
        "from": {
            "userId": "customer@example.com",
            "name": "Customer"
        }
    },
    {
        "payload": {
            "content": "Goodbye, John. Take care!"
        },
        "from": {
            "userId": "suprabath.chakilam@symbl-support.ai",
            "name": "Suprabath"
        }
    }
]


const HUMAN_SALES_CALL_TRANSCRIPT = [
    {
        "payload": {
            "content": "Hi, is this Mark?"
        },
        "from": {
            "userId": "bailey.johnson@symbl.ai",
            "name": "Bailey Johnson"
        }
    },
    {
        "payload": {
            "content": "Yes, this is Mark. Who's calling?"
        },
        "from": {
            "userId": "mark.keely@prospect.com",
            "name": "Mark Keely"
        }
    },
    {
        "payload": {
            "content": "Hi Mark, this is Bailey from Symbl.ai. How are you today?"
        },
        "from": {
            "userId": "bailey.johnson@symbl.ai",
            "name": "Bailey Johnson"
        }
    },
    {
        "payload": {
            "content": "I'm doing well, thanks. How can I help you?"
        },
        "from": {
            "userId": "mark.keely@prospect.com",
            "name": "Mark Keely"
        }
    },
    {
        "payload": {
            "content": "Great to hear! I'm reaching out because I noticed you recently checked out our website. Symbl.ai is at the forefront of AI-driven SaaS solutions, and I wanted to see if you'd be interested in learning more about how our products can benefit your business."
        },
        "from": {
            "userId": "bailey.johnson@symbl.ai",
            "name": "Bailey Johnson"
        }
    },
    {
        "payload": {
            "content": "Yeah, I did browse through it. But I'm not sure if it's what we need right now."
        },
        "from": {
            "userId": "mark.keely@prospect.com",
            "name": "Mark Keely"
        }
    },
    {
        "payload": {
            "content": "I understand, Mark. Could you tell me a bit about what you're currently using and the challenges you're facing? Maybe I can help identify if there's a fit."
        },
        "from": {
            "userId": "bailey.johnson@symbl.ai",
            "name": "Bailey Johnson"
        }
    },
    {
        "payload": {
            "content": "Well, we're using a combination of tools for customer support and sales, but they don't integrate well, and we end up spending a lot of time manually consolidating data."
        },
        "from": {
            "userId": "mark.keely@prospect.com",
            "name": "Mark Keely"
        }
    },
    {
        "payload": {
            "content": "That sounds like a common issue. Symbl.ai offers a unified platform that seamlessly integrates with your existing tools. Our AI-powered solutions automate data consolidation and provide actionable insights in real-time, drastically reducing manual effort and improving efficiency. Would that be something you're interested in?"
        },
        "from": {
            "userId": "bailey.johnson@symbl.ai",
            "name": "Bailey Johnson"
        }
    },
    {
        "payload": {
            "content": "Hmm, it does sound interesting. But how reliable is it? We've had issues with AI tools in the past not being as accurate as promised."
        },
        "from": {
            "userId": "mark.keely@prospect.com",
            "name": "Mark Keely"
        }
    },
    {
        "payload": {
            "content": "I hear you, Mark. Accuracy is critical. Symbl.ai's platform is built on state-of-the-art machine learning models that have been rigorously tested and refined. We boast a 99.9% accuracy rate in data processing and insight generation. Plus, our system continuously learns and improves over time, ensuring it adapts to your specific needs."
        },
        "from": {
            "userId": "bailey.johnson@symbl.ai",
            "name": "Bailey Johnson"
        }
    },
    {
        "payload": {
            "content": "That's impressive. But what about customer support? We need quick responses when issues arise."
        },
        "from": {
            "userId": "mark.keely@prospect.com",
            "name": "Mark Keely"
        }
    },
    {
        "payload": {
            "content": "Absolutely, support is a top priority for us. We offer 24/7 customer support with dedicated account managers who are always ready to assist. Our support team is highly trained and ensures that any issues are resolved promptly. Additionally, our comprehensive documentation and community forums provide extensive resources for self-help."
        },
        "from": {
            "userId": "bailey.johnson@symbl.ai",
            "name": "Bailey Johnson"
        }
    },
    {
        "payload": {
            "content": "Alright, Bailey, you've got my attention. Can you give me an example of how Symbl.ai has helped another company with similar challenges?"
        },
        "from": {
            "userId": "mark.keely@prospect.com",
            "name": "Mark Keely"
        }
    },
    {
        "payload": {
            "content": "Sure! One of our clients, a mid-sized tech company, faced similar integration issues. After implementing Symbl.ai, they saw a 40% reduction in time spent on manual data consolidation and a 30% increase in team productivity. Our platform's insights helped them identify and act on customer pain points more effectively, leading to a 20% boost in customer satisfaction scores."
        },
        "from": {
            "userId": "bailey.johnson@symbl.ai",
            "name": "Bailey Johnson"
        }
    },
    {
        "payload": {
            "content": "That's pretty convincing. But what's the pricing like? We have a tight budget."
        },
        "from": {
            "userId": "mark.keely@prospect.com",
            "name": "Mark Keely"
        }
    },
    {
        "payload": {
            "content": "Our pricing is flexible and designed to scale with your needs. We offer various plans starting from small business packages to enterprise-level solutions. Given your requirements, we can tailor a package that fits your budget while maximizing the value you get from our platform. How about we schedule a demo so you can see the product in action and discuss pricing in detail?"
        },
        "from": {
            "userId": "bailey.johnson@symbl.ai",
            "name": "Bailey Johnson"
        }
    },
    {
        "payload": {
            "content": "A demo sounds good. I'd like to see how it works before making any decisions."
        },
        "from": {
            "userId": "mark.keely@prospect.com",
            "name": "Mark Keely"
        }
    },
    {
        "payload": {
            "content": "Great! I'll send you a calendar invite for tomorrow at 2 PM. Does that time work for you?"
        },
        "from": {
            "userId": "bailey.johnson@symbl.ai",
            "name": "Bailey Johnson"
        }
    },
    {
        "payload": {
            "content": "Yes, 2 PM works."
        },
        "from": {
            "userId": "mark.keely@prospect.com",
            "name": "Mark Keely"
        }
    },
    {
        "payload": {
            "content": "Perfect! I'll send the invite shortly. Looking forward to showing you how Symbl.ai can transform your workflow. Thanks for your time today, Mark."
        },
        "from": {
            "userId": "bailey.johnson@symbl.ai",
            "name": "Bailey Johnson"
        }
    },
    {
        "payload": {
            "content": "Thank you, Bailey. Talk to you tomorrow."
        },
        "from": {
            "userId": "mark.keely@prospect.com",
            "name": "Mark Keely"
        }
    },
    {
        "payload": {
            "content": "Goodbye, Mark!"
        },
        "from": {
            "userId": "bailey.johnson@symbl.ai",
            "name": "Bailey Johnson"
        }
    }
]


export {
    HUMAN_SALES_CALL_TRANSCRIPT,
    HUMAN_SUPPORT_CALL_TRANSCRIPT,
}